import React from 'react';
import {Button} from "@chakra-ui/react";
import {modalPrimaryButtonProps, modalSecondaryButtonProps} from "../../theme/modalActionButtons.ts";

interface CreateProjectModalFooterProps {
  activeStep: number;
  finalStep: number;
  finalStepTitle: string;
  canContinueToNextStep: boolean;
  isFinalStepDisabled: boolean;
  isFinalStepLoading?: boolean;
  goToNext: () => void;
  goToPrevious: () => void;
  onFinalStepClicked: () => void;
}

const CreateProjectModalFooter: React.FC<CreateProjectModalFooterProps> = (
  {
    activeStep,
    finalStep,
    finalStepTitle,
    canContinueToNextStep,
    isFinalStepDisabled,
    isFinalStepLoading = false,
    goToNext,
    goToPrevious,
    onFinalStepClicked,
  }: CreateProjectModalFooterProps) => {
  const isFirstStep: boolean = activeStep <= 0;
  const isFinalStep: boolean = activeStep >= finalStep;

  return (
    <>
      {!isFirstStep && (
        <Button {...modalSecondaryButtonProps} onClick={goToPrevious}>
          Back
        </Button>
      )}
      {!isFinalStep && (
        <Button
          {...modalPrimaryButtonProps}
          isDisabled={!canContinueToNextStep}
          onClick={() => canContinueToNextStep && goToNext()}
        >
          Next
        </Button>
      )}
      {isFinalStep && (
        <Button
          {...modalPrimaryButtonProps}
          isDisabled={isFinalStepDisabled}
          isLoading={isFinalStepLoading}
          loadingText={finalStepTitle}
          onClick={onFinalStepClicked}
        >
          {finalStepTitle}
        </Button>
      )}
    </>
  );
}

export default CreateProjectModalFooter;
